module.exports = __webpack_public_path__ + "static/media/main.95a6f40a.jpg";